import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function FinalCta() {
  return <Section id="comprar" className="bg-gradient-to-b from-[#0f1923] to-[#1a2740] text-center !py-20" data-id="element-23">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-24">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-white leading-tight" data-id="element-25">
          Si hoy tu casa vive una tensión diaria por pantallas, no necesitas
          otro video con "tips".
        </h2>

        <p className="text-xl text-gray-300 leading-relaxed" data-id="element-26">
          Necesitas un plan que funcione en el momento real: cuando estás
          cansado, cuando hay berrinche, cuando no hay paciencia, cuando lo
          fácil sería ceder.
        </p>

        <p className="text-sm text-gray-500 italic" data-id="element-27">
          *Este material es educativo y no reemplaza acompañamiento profesional
          cuando se requiere.
        </p>

        <div className="py-6" data-id="element-28">
          <p className="text-4xl font-bold text-white mb-1" data-id="element-29">S/ 21.50</p>
          <p className="text-sm text-gray-400 mb-5" data-id="element-30">Precio único</p>
          <Button variant="primary" className="text-xl px-12 py-6 shadow-[0_0_30px_rgba(201,168,76,0.3)] hover:shadow-[0_0_50px_rgba(201,168,76,0.5)] scale-105" onClick={() => window.open('https://narelaspace.com/cart/47551208456412:1', '_blank')} data-id="element-31">
            Quiero el Plan Anti-Pantalla 30 Días
          </Button>
          <p className="mt-4 text-sm text-gray-500" data-id="element-32">
            Pago único • Acceso inmediato • Garantía de satisfacción
          </p>
        </div>

        <div className="pt-6 border-t border-gray-800" data-id="element-33">
          <p className="text-gray-400 font-serif italic" data-id="element-34">
            Empieza hoy. Imprime las plantillas. Pega las reglas. Instala el
            sistema.
          </p>
        </div>
      </div>
    </Section>;
}